import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IxeeHome from "./ixee/IxeeSite";
import { IxeePrivacy, IxeeTerms, IxeeDeleteAccount } from "./ixee/IxeeLegal";

/**
 * IXEE website (ixee.ai) — rebuilt 2026-10-21 on the ixee-website branch.
 * The legacy Goollooper pages remain in src/Pages and src/Components, unrouted.
 * (This also drops the legacy react-ga analytics wiring — it pointed at the
 * old Goollooper GA property and must not carry over to IXEE.)
 */
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IxeeHome />} />
        <Route path="/privacy" element={<IxeePrivacy />} />
        <Route path="/terms" element={<IxeeTerms />} />
        <Route path="/delete-account" element={<IxeeDeleteAccount />} />
      </Routes>
    </Router>
  );
}

export default App;
